import React from 'react';
import PropTypes from 'prop-types';
import LinearProgressBar from './LinearProgressBar';
import CircularProgressBar from './CircularProgressBar';

const ProgressBar = ({
  value,
  circular,
  className,
}) => {
  let component = null;
  if (circular) {
    component = <CircularProgressBar value={value} className={className} />;
  } else {
    component = <LinearProgressBar value={value} className={className} />;
  }

  return component;
};

ProgressBar.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  circular: PropTypes.bool,
};

ProgressBar.defaultProps = {
  className: '',
  value: 0,
  circular: false,
};

export default ProgressBar;
